import I18n from 'I18n';
import { CardIcon } from 'foundations-assets/icons/components/CardIcon';
import { ChevronsOutwardIcon } from 'foundations-assets/icons/components/ChevronsOutwardIcon';
import { GapHorizontalIcon } from 'foundations-assets/icons/components/GapHorizontalIcon';
import { LinkIcon } from 'foundations-assets/icons/components/LinkIcon';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { TextIcon } from 'foundations-assets/icons/components/TextIcon';
import { FIELD_TYPES, TOOL_TYPES } from '../constants';
import { AlignmentTool } from './AlignmentTool';
import { ChoiceTool } from './ChoiceTool';
import { LinkTool } from './LinkTool';
import { IconTool } from './IconTool';
import { ImageTool } from './ImageTool';
export const TOOL_REGISTRY = {
  [TOOL_TYPES.ALIGNMENT]: {
    matches: f => f.type === FIELD_TYPES.ALIGNMENT || f.type === FIELD_TYPES.TEXT_ALIGNMENT,
    Component: AlignmentTool,
    getLabel: field => field.label || I18n.text('InpageEditorUI.inpage.fieldSettingsToolbar.alignment.label')
  },
  [TOOL_TYPES.SIZE]: {
    matches: f => f.type === FIELD_TYPES.CHOICE && Array.isArray(f.choices) && f.name.toLowerCase().includes('size'),
    Component: ChoiceTool,
    getIcon: () => ChevronsOutwardIcon,
    getLabel: field => field.label || field.name
  },
  [TOOL_TYPES.GAP]: {
    matches: f => f.type === FIELD_TYPES.CHOICE && Array.isArray(f.choices) && f.name.toLowerCase().includes('gap'),
    Component: ChoiceTool,
    getIcon: () => GapHorizontalIcon,
    getLabel: field => field.label || field.name
  },
  [TOOL_TYPES.VARIANT]: {
    matches: f => {
      if (f.type !== FIELD_TYPES.CHOICE || !Array.isArray(f.choices)) return false;
      const lowerName = f.name.toLowerCase();
      return lowerName.includes('variant') || lowerName.includes('style');
    },
    Component: ChoiceTool,
    getIcon: () => CardIcon,
    getLabel: field => field.label || field.name
  },
  [TOOL_TYPES.HEADING_LEVEL]: {
    matches: f => f.type === FIELD_TYPES.CHOICE && Array.isArray(f.choices) && f.name.toLowerCase().includes('level'),
    Component: ChoiceTool,
    getIcon: () => TextIcon,
    getLabel: field => field.label || I18n.text('InpageEditorUI.inpage.fieldSettingsToolbar.headingLevel.label')
  },
  [TOOL_TYPES.LINK]: {
    matches: f => f.type === FIELD_TYPES.LINK,
    Component: LinkTool,
    getIcon: () => LinkIcon,
    getLabel: field => field.label || I18n.text('InpageEditorUI.inpage.fieldSettingsToolbar.link.label')
  },
  [TOOL_TYPES.ICON]: {
    matches: f => f.type === FIELD_TYPES.ICON,
    Component: IconTool,
    getIcon: () => InsertImageIcon,
    getLabel: field => field.label || I18n.text('InpageEditorUI.inpage.fieldSettingsToolbar.icon.label')
  },
  [TOOL_TYPES.IMAGE]: {
    matches: f => f.type === FIELD_TYPES.IMAGE,
    Component: ImageTool,
    getLabel: () => I18n.text('inpage.fieldSettingsToolbar.image.label')
  }
};